export default __webpack_public_path__ + "static/media/img-3.86096d58.png";